import Axios from "axios";
import { CMSPath } from "../config/constant";

export const way_activity_booking_base_url = Axios.create({baseURL: `${CMSPath}/spaWebApplication/rest`});
export const WAY_ACTIVITIES_USER_DATA = "way_activity_user_data";

export const getAllEventsList = async (locationId) => {

    const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

    const payload = {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
        },
        "payload": {
        }
     }

    try {
        let {data} = await way_activity_booking_base_url.post(`/getEvents`,payload)
        return data.payload.data
    } catch (error) {
        const errMessage = error && error.response && error.response.header && error.response.header.status && error.response.header.status.msg ? error.response.header.status.msg : "Something Went wrong"
        throw new Error(errMessage)
    }
    
}


export const getAllWayBookings = async () => {

    const payload = {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
        },
        "payload": {
            // email: "test@innspire.co"
        }
     }

    try {
        let {data} = await way_activity_booking_base_url.post(`/fetchBookings`,payload)
        return data.payload.Data.items
    } catch (error) {
        const errMessage = error && error.response && error.response.header && error.response.header.status && error.response.header.status.msg ? error.response.header.status.msg : "Something Went wrong"
        throw new Error(errMessage)
    }
    
}

export const getEventInfoWayActivity = async (id) => {

    const payload = {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
        },
        "payload": {
            listingId: id
        }
     }

    try {
        let {data} = await way_activity_booking_base_url.post(`/getEventsInfo`, payload)
        return data.payload.data
    } catch (error) {
        const errMessage = error && error.response && error.response.header && error.response.header.status && error.response.header.status.msg ? error.response.header.status.msg : "Something Went wrong"
        throw new Error(errMessage)
    }
    
}


export const getWayActivityAvailability = async (experienceId, date, subEvent) => {

    const payload = {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
        },
        "payload": {
            experienceId,
            date,
            experienceIdsList : subEvent ? subEvent.experiencesIds : undefined
        }
    }

    try {
        let {data} = await way_activity_booking_base_url.post(`/getAvailbility`, payload)
        return data.payload.data
    } catch (error) {
        const errMessage = error && error.response && error.response.header && error.response.header.status && error.response.header.status.msg ? error.response.header.status.msg : "Something Went wrong"
        throw new Error(errMessage)
    }
    
}

export const createTheWayActivityBooking = async (payload_) => {

    const payload = {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
        },
        payload:payload_
    }

    try {
        let {data} = await way_activity_booking_base_url.post(`/createBooking`, payload)
        return data.payload.data
    } catch (error) {
        const errMessage = error && error.response && error.response.header && error.response.header.status && error.response.header.status.msg ? error.response.header.status.msg : "Something Went wrong"
        throw new Error(errMessage)
    }
    
}



export const cancelWayBooking = async (payload_) => {

    const payload = {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
        },
        payload:payload_
    }

    try {
        let {data} = await way_activity_booking_base_url.post(`/cancel`, payload)
        return data.payload.data
    } catch (error) {
        const errMessage = error && error.response && error.response.header && error.response.header.status && error.response.header.status.msg ? error.response.header.status.msg : "Something Went wrong"
        throw new Error(errMessage)
    }
    
}

export const updateMyWayBooking = async (payload_) => {

    const payload = {
        "header": {
          "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
        },
        payload:payload_
    }

    try {
        let {data} = await way_activity_booking_base_url.post(`/booking/reschedule`, payload)
        return data.payload.data
    } catch (error) {
        const errMessage = error && error.response && error.response.header && error.response.header.status && error.response.header.status.msg ? error.response.header.status.msg : "Something Went wrong"
        throw new Error(errMessage)
    }
    
}